import { Overlay, OverlayRef } from "@angular/cdk/overlay";
import { Injectable, Injector } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
	providedIn: "root",
})
export class OverlayService {
	private isBusy: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	/** Reference to currently open overlay. */
	public overlayInstance: OverlayRef;
	private closePending = 0;

	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	constructor(private injector: Injector, public overlay: Overlay) {}

	public get isBusy$() {
		return this.isBusy.asObservable();
	}
	public open(): void {
		this.closePending++;

		if (this.closePending === 1) {
			this.isBusy.next(true);
			// // need to create an overlay
			// this.overlayInstance = this.overlay.create({
			// 	positionStrategy: this.overlay.position().global().centerHorizontally().centerVertically(),
			// 	hasBackdrop: true,
			// });

			// this.overlayInstance.attach(
			// 	new ComponentPortal(
			// 		OverlayComponent,
			// 		null,
			// 		new PortalInjector(this.injector, new WeakMap([[OVERLAY_OPTIONS, {}]])),
			// 	),
			// );
		}
	}

	public close(): void {
		this.closePending--;

		if (!this.closePending) {
			// this.overlayInstance?.dispose();

			this.isBusy.next(false);
		}
	}
}
